import { OrgPageLiveEditorStepKey } from "../Steps/OrgPageLiveEditorStep.enum";

import { isOrgPageNewslettersEnabled } from "@/common/constants/orgPageNewsletters";

type OrgPageStepKey = Extract<
  OrgPageLiveEditorStepKey,
  | "color"
  | "banner"
  | "logo"
  | "main-ctas"
  | "description"
  | "org-information"
  | "events"
  | "support-forms"
  | "newsletters"
  | "review"
>;

const ORG_PAGE_STEPS: { key: OrgPageStepKey; shouldBeSkip?: boolean }[] = [
  { key: "color" },
  { key: "banner" },
  { key: "logo" },
  { key: "main-ctas" },
  { key: "description" },
  { key: "events" },
  { key: "support-forms" },
  { key: "newsletters", shouldBeSkip: !isOrgPageNewslettersEnabled },
  { key: "org-information" },
  { key: "review" },
];

export const isAvailableOrgPageStepKey = (key: unknown): key is OrgPageLiveEditorStepKey =>
  ORG_PAGE_STEPS.some((step) => step.key === key && !step.shouldBeSkip);

export const useGetAllOrgPageStepsInOrder = () => ({ steps: ORG_PAGE_STEPS });
